'use strict';

module.exports =
	'<form class="ad-component_search" name="searchForm" id="idc" method="get" action="/listing">' +
		'<div class="ad-component_search--input">' +
			'<label>Search: </label>' +
			'<input type="text" maxlength="200" value="" name="q" placeholder="">' +
		'</div>' +
		'<button class="ad-component_search--button" type="submit" aria-label="Search">' +
			'<i class="adb-icon__search"></i>' +
		'</button>' +
	'</form>';







//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/templates/ad-search-form.tpl.js
// module id = 30
// module chunks = 0